import { ButtonsPrimary } from '../../ComponentApp/buttoms';
import {
  RescueBodyContainer,
  RescueContentContent,
  SectionSelectRescue,
  SelectContent,
  TitleAndAmountContainer,
  TitleContainerRescue,
  TitleSectionRescue,
  TitleTextRescue,
} from './RescueComponent';
import SelectRescueItem from './SelectRescueItem';
import ValueSection from './ValueSection';

const CardsContinersRescue = ({
  handleAmountRescue,
  amountRescue,
  valueSelect,
  handleSubmitRescue,
  marketValue,
  typeProduct,
}) => {
  return (
    <RescueBodyContainer>
      <TitleAndAmountContainer>
        <TitleContainerRescue>
          <TitleTextRescue>Rescatar inversión</TitleTextRescue>
        </TitleContainerRescue>
        <ValueSection marketValue={marketValue} typeProduct={typeProduct} />
      </TitleAndAmountContainer>

      <RescueContentContent>
        <SelectContent>
          <TitleSectionRescue>¿Cuánto deseas rescatar?</TitleSectionRescue>
          <SectionSelectRescue>
            <SelectRescueItem
              valueSelect={valueSelect}
              amountRescue={amountRescue}
              handleAmountRescue={handleAmountRescue}
            />
          </SectionSelectRescue>
        </SelectContent>
        <ButtonsPrimary
          sx={{
            mt: 5,
            mr: 1,
          }}
          name='Rescate portfolio'
          onClick={() => handleSubmitRescue()}
        />
      </RescueContentContent>
    </RescueBodyContainer>
  );
};

export default CardsContinersRescue;
